"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoutingTablesCache = void 0;
const lru_cache_1 = require("lru-cache");
const createRoutingTableId = (targetId, previousId) => {
    return targetId + (previousId ?? '');
};
const DEFAULT_LRU_OPTIONS = {
    max: 1000,
    maxAge: 15 * 1000
};
/**
 * RoutingTablesCache is a cache for routing tables.
 * It is used to store the routing tables for a specific targetId and previousId.
 * Storing the previousId is important as it is used as a minimum distance for the contacts in the table.
 * Calculating a RoutingTable from scratch is an O(n log n) operation (n = number of connections of a node)
 * However,
 * - Adding a contact to a RoutingTable is an O(log n) operation.
 * - Deleting a contact from a RoutingTable is an O(1) operation.
 * Thus, holding the most frequently used routing tables in memory to be updated on
 * connections and disconnections is hugely beneficial in terms of performance.
*/
class RoutingTablesCache {
    tables = new lru_cache_1.LRUCache(DEFAULT_LRU_OPTIONS);
    get(targetId, previousId) {
        return this.tables.get(createRoutingTableId(targetId, previousId));
    }
    set(targetId, table, previousId) {
        this.tables.set(createRoutingTableId(targetId, previousId), table);
    }
    has(targetId, previousId) {
        return this.tables.has(createRoutingTableId(targetId, previousId));
    }
    onNodeDisconnected(nodeId) {
        this.tables.forEach((table) => table.removeContact(nodeId));
    }
    onNodeConnected(remote) {
        this.tables.forEach((table) => table.addContact(remote));
    }
    reset() {
        this.tables.forEach((table) => table.stop());
        this.tables.clear();
    }
}
exports.RoutingTablesCache = RoutingTablesCache;
//# sourceMappingURL=RoutingTablesCache.js.map